"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const Paths = __importStar(require("../../constants/Paths"));
const ChangeRequestModal_1 = __importDefault(require("../ChangeRequestModal"));
const TabsNavigation_1 = __importDefault(require("../TabsNavigation"));
class AssetsPage extends react_1.default.Component {
    scopeReactionDisposer;
    componentDidMount() {
        document.title = (0, translation_1.t)('portal_subpage_title', { title: (0, translation_1.t)('myassets.page_title') });
        this.scopeReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.claims, () => {
            const hasAtLeastOneRequiredScope = this.props.route?.routes?.some((route) => AuthorizationStore_1.default.hasScope(route.scope));
            if (!hasAtLeastOneRequiredScope) {
                this.props.history.replace(Paths.PATH_HOME);
            }
        });
    }
    componentWillUnmount() {
        this.scopeReactionDisposer?.();
    }
    render() {
        return (react_1.default.createElement("section", { className: "znd-assets-page" },
            react_1.default.createElement("div", { className: "znd-top-page d-flex justify-content-between align-items-center" },
                react_1.default.createElement("h1", { className: "znd-top-page__title t-headline-2" }, (0, translation_1.t)('myassets.title')),
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.CHANGE_CREATE] },
                    react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.white, className: "znd-assets-page__btn-change-request", text: (0, translation_1.t)('myassets.change_request.btn'), icon: Zupicons_1.default.fileAlt, onClick: () => {
                            (0, GlobalModal_1.showModal)({
                                component: ChangeRequestModal_1.default,
                                props: {
                                    title: (0, translation_1.t)('myassets.change_request.title'),
                                    topic: ecommerce_1.ChangeRequestTopicEnum.Assets,
                                },
                            });
                        } }))),
            react_1.default.createElement(TabsNavigation_1.default, { className: "znd-tabs__category-navigation", routes: this.props.route?.routes ?? [] }),
            (0, react_router_config_1.renderRoutes)(this.props.route?.routes)));
    }
}
exports.default = (0, mobx_react_1.observer)(AssetsPage);
